import { render, staticRenderFns } from "./QuestionCreateAutoOfExamModal.vue?vue&type=template&id=117f12c6"
import script from "./QuestionCreateAutoOfExamModal.vue?vue&type=script&lang=js"
export * from "./QuestionCreateAutoOfExamModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionCreateAutoOfExamModal.vue?vue&type=style&index=0&id=117f12c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports